import { useMemo } from 'react'
import { Column } from 'react-table'
import { BasicTable } from 'components/BasicTable'
import { useContent } from 'lib/content/react'
import { Cell } from 'react-table'
import { IncentivePlan } from 'types/entities'
import {
  ActionCallbacks,
  Available,
  Status,
  Actions,
  Title,
  Type,
} from './utils'

export type IncentivePlansTableProps = {
  incentivePlans?: IncentivePlan[]
} & ActionCallbacks

export const IncentivePlansTable = ({
  incentivePlans = [],
  ...actionCallbacks
}: IncentivePlansTableProps) => {
  const { formatMessage } = useContent()
  const columns = useMemo<Column<IncentivePlan>[]>(
    () => [
      {
        id: 'title',
        accessor: ({ incentiveDetails }) => incentiveDetails.name,
        Header: formatMessage({ id: 'pmportal.incentives.titleColumn' }),
        Cell: Title,
      },
      {
        id: 'type',
        accessor: ({ incentiveDetails }) => incentiveDetails.type,
        Header: formatMessage({ id: 'pmportal.incentives.typeColumn' }),
        Cell: Type,
      },
      {
        id: 'available',
        accessor: ({ incentiveDetails }) => incentiveDetails.schedule?.type,
        Header: formatMessage({ id: 'pmportal.incentives.availableColumn' }),
        Cell: Available,
      },
      {
        accessor: 'status',
        Header: formatMessage({ id: 'pmportal.incentives.statusColumn' }),
        Cell: Status,
      },
      {
        id: 'actions',
        Cell: ({ row: { original } }: Cell<IncentivePlan>) => (
          <Actions incentivePlan={original} {...actionCallbacks} />
        ),
      },
    ],
    [formatMessage, actionCallbacks]
  )
  return (
    <BasicTable
      columns={columns}
      data={incentivePlans}
      placeholder={formatMessage({
        id: 'pmportal.incentives.noIncentivePlans',
      })}
      tdProps={() => ({ lineHeight: 'inherit' })}
    />
  )
}
